import { makeRowIterator } from '@loaders.gl/schema';
export function encodeTableAsJSON(table, options) {
  var _options$json;
  const shape = (options === null || options === void 0 ? void 0 : (_options$json = options.json) === null || _options$json === void 0 ? void 0 : _options$json.shape) || 'object-row-table';
  const strings = [];
  const rowIterator = makeRowIterator(table, shape);
  for (const row of rowIterator) {
    strings.push(JSON.stringify(row));
  }
  return `[${strings.join(',')}]`;
}
//# sourceMappingURL=json-encoder.js.map